<div class="full-screen d-flex align-items-center pt-30 pb-30 pt-lg-0 pb-lg-0" [style.Opacity]="isLoadingContext || isSubmitting || isRedirecting ? '0.5' : '1'">
<div class="container-fluid">
<div class="row justify-content-lg-start justify-content-center">
    <div class="col-lg-2 d-none d-lg-block"></div>
    <div class="col-12 col-lg-10">

        <h1 class="font__family-montserrat font__weight-bold font__size-42 line__height-42 mt-0 mb-45 text-center text-lg-left">Acessar Eleição CIPA</h1>

        <div *ngIf="isLoadingContext" class="brk-form brk-form-strict maxw-570 mx-auto mx-lg-0" data-brk-library="component__form">
            <div class="alert alert-clean fade alert-info text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show" role="alert" data-brk-library="component__alert">
                <i class="start-icon far fa-spinner-third fa-spin"></i>
                <strong class="font__weight-semibold">Validando eleição...</strong> Aguarde enquanto localizamos as informações do acesso.
            </div>
        </div>

        <form *ngIf="!isLoadingContext && electionContext" (submit)="autenticar($event)" [formGroup]="modelo" class="brk-form brk-form-strict maxw-570 mx-auto mx-lg-0" data-brk-library="component__form" [class.submitted]='submetido === true' autocomplete="off">

            <div class="alert alert-clean fade alert-primary text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show" role="alert" data-brk-library="component__alert">
                <div class="election-context__header mb-3">
                    <i class="start-icon far fa-building"></i>
                    <span class="font__size-11 letter-spacing-30 text-uppercase font__weight-semibold">Estabelecimento</span>
                </div>
                <strong class="font__weight-bold d-block font__size-18 line__height-24 mb-0">{{ electionContext.establishmentName }}</strong>
                <span class="d-block font__size-13 line__height-18 mt-0 election-context__reg">
                    <span class="font__weight-semibold text-uppercase">{{ electionContext.establishmentRegistrationNumberType }}</span>
                    {{ formatRegistrationNumber(electionContext.establishmentRegistrationNumber, electionContext.establishmentRegistrationNumberType) }}
                </span>
                <div class="election-context__divider"></div>
                <p class="mb-0 mt-0 font__size-14 line__height-20">Confirme seus dados de identificação para seguir com a votação.</p>
            </div>

            <div *ngIf="error !== ''" class="alert alert-clean fade alert-warning alert-dismissible text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show" role="alert" data-brk-library="component__alert">
                <button type="button" class="close font__size-18" data-dismiss="alert" (click)="error = ''">
                    <span aria-hidden="true">
                        <i class="fal fa-times"></i>
                    </span>
                    <span class="sr-only">Fechar</span>
                </button>
                <i class="start-icon far fa-exclamation-triangle"></i>
                <strong class="font__weight-semibold">Ops, ocorreu um problema!</strong> {{ error }}
            </div>

            <div *ngIf="infoMessage !== ''" class="alert alert-clean fade alert-info alert-dismissible text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show" role="alert" data-brk-library="component__alert">
                <button type="button" class="close font__size-18" data-dismiss="alert" (click)="infoMessage = ''">
                    <span aria-hidden="true">
                        <i class="fal fa-times"></i>
                    </span>
                    <span class="sr-only">Fechar</span>
                </button>
                <i class="start-icon far fa-info-circle"></i>
                {{ infoMessage }}
            </div>

            <input type="text" placeholder="CPF" name="cpf" formControlName="cpf" inputmode="numeric" autocomplete="off" [readonly]="isSubmitting">

            <div *ngIf="submetido && modelo.get('cpf')?.errors?.['required']" class="error-text">
                Este campo é obrigatório.
            </div>

            <div *ngIf="submetido && modelo.get('cpf')?.errors?.['cpfLength']" class="error-text">
                Informe um CPF válido com 11 números.
            </div>

            <app-birth-date-input
                inputId="participant-birth-date"
                formControlName="birthDate"
                autocomplete="off"
                [readonly]="isSubmitting">
            </app-birth-date-input>

            <div *ngIf="submetido && modelo.get('birthDate')?.errors?.['required']" class="error-text">
                Este campo é obrigatório.
            </div>

            <div *ngIf="submetido && modelo.get('birthDate')?.errors?.['invalidBirthDate']" class="error-text">
                Informe uma data válida no padrão dd/mm/yyyy.
            </div>

            <input *ngIf="requiresPassword" #password type="password" placeholder="Senha" formControlName="password" autocomplete="new-password" [readonly]="isSubmitting">

            <div *ngIf="requiresPassword && submetido && modelo.get('password')?.errors?.['required']" class="error-text">
                Este campo é obrigatório.
            </div>

            <div class="no-margin pl-10 pr-10 mb-30 mt-40 d-flex flex-wrap justify-content-between align-items-center">
                <div>
                    <label class="brk-form-checkbox">
                    <input id="checkbox-strict-1" name="checkbox" type="checkbox" formControlName="lembrarMe"
                    class="rendered" [disabled]="isSubmitting"><span class="checkbox-custom">
                        <i class="fa fa-check" aria-hidden="true"></i></span>
                    </label>
                    <label for="checkbox-strict-1" class="brk-form-checkbox-label">Lembrar-me</label>
                </div>

                <!--
                <div>
                    <a class="font__size-14 line__height-24 brk-base-font-color text-decoration_underline" href="javascript:void(0)" (click)="!isSubmitting && recuperarSenha()">Esqueceu sua senha?</a>
                </div>-->
            </div>
            <div class="d-flex flex-wrap justify-content-center align-items-right flex-column flex-lg-row">
                <button type="submit" class="btn-backgrounds btn-backgrounds btn__full_width btn-backgrounds_280 btn-backgrounds_white btn-backgrounds_left-icon font__family-montserrat font__weight-bold text-uppercase font__size-13 z-index-2 text-center letter-spacing-20 mt-10" data-brk-library="component__button" [disabled]="isSubmitting || isLoadingContext">
                    <span class="text">{{ submitButtonText }}</span>
                    <span class="before"><i class="far fa-hand-point-right"></i></span>
                </button>
            </div>
        </form>
    </div>
</div>
</div>
</div>
